import { render, staticRenderFns } from "./previewCard1.vue?vue&type=template&id=f87ff6d6&scoped=true"
import script from "./previewCard1.vue?vue&type=script&lang=js"
export * from "./previewCard1.vue?vue&type=script&lang=js"
import style0 from "./previewCard1.vue?vue&type=style&index=0&id=f87ff6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87ff6d6",
  null
  
)

export default component.exports